import { render, staticRenderFns } from "./FormPanel.vue?vue&type=template&id=58b806f4&"
import script from "./FormPanel.vue?vue&type=script&lang=js&"
export * from "./FormPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports